import { HttpClient, HttpParams, HttpHeaders, HttpErrorResponse } from '@angular/common/http';
import { HttpClientBaseService } from './base/httpClientBase.service';
import { Injectable } from '@angular/core';
import { forkJoin, Observable, of, throwError } from 'rxjs';
import { AppUsuario } from '../models/appUsuario.model';
import { AppEmpresasService } from './appEmpresasService.service';
import { IServiceBase } from './base/IServiceBase';
import { PageList } from '../models/pageList.model';
import { AppConfig } from '../configuration/app.config';
import { catchError, map, switchMap } from 'rxjs/operators';
import { LivesSessionHelper } from '../helper/livesSessionHelper';


//usuarios copy ARREGLAR (son los métodos de get y set)

@Injectable({ providedIn: 'root' })
export class AppUsuarioService extends HttpClientBaseService implements IServiceBase<AppUsuario> {

    constructor(
        _http: HttpClient,
        private appEmpresasService: AppEmpresasService,
        private _livesSession: LivesSessionHelper
    ) {
        super(_http, '/user/', '', false);


    }
    getPagedModels(parentId?: any, params?: HttpParams): Observable<PageList<AppUsuario>> {
        throw new Error('Method not implemented.');
    }

    /* obtener datos del usaurio a partir del mail */
    public getModelByMail(mail: any): Observable<AppUsuario> {
        const url = `${AppConfig.settings.apiServerPE.apiUrl}user?top=1&orderBy=hiringDate&order=desc&fields=enabled&fields=mail&operator=eq&operator=eq&values=true&values=${mail}`;

        // Crear los headers con la clave API
        const headers = new HttpHeaders({
            'X-API-KEY': AppConfig.settings.apiServerPE.apiKey
        });

        // Realizar la petición GET y devolver el resultado como un Observable
        return this.http.get<AppUsuario>(url, { headers: headers });
    }

    /*   getAllModels(): Observable<AppUsuario[]> {
        return super.getAll<AppUsuario[]>();
      } */

    getAllForSelect(): Observable<any> {
        // Datos estáticos
        const data = [

            new AppUsuario()
        ];
        return of(data);
    }


    getAllForSelectByCompany(companyId: any, enabled: boolean = false): Observable<any> {
        const environmentId = this._livesSession.EnvironmentId;
        if (!environmentId) {
            return throwError(new Error("No environment ID found in session storage"));
        }

        const url = !enabled ? `${AppConfig.settings.apiServerPE.apiUrl}user?fields=company&fields=environment&operator=eq&operator=eq&values=${companyId}&values=${environmentId}` : `${AppConfig.settings.apiServerPE.apiUrl}user?fields=company&fields=enabled&fields=environment&operator=eq&operator=eq&operator=eq&values=${companyId}&values=${enabled}&values=${environmentId}`;

        // Crear los headers con la clave API
        const headers = new HttpHeaders({
            'X-API-KEY': AppConfig.settings.apiServerPE.apiKey
        });

        // Realizar la petición GET y devolver el resultado como un Observable
        return this.http.get<AppUsuario[]>(url, { headers: headers });

    }

    getAllForSelectByCompanyNif(companyNif: any, enabled: boolean = false): Observable<any> {
        const environmentId = this._livesSession.EnvironmentId;
        if (!environmentId) {
            return throwError(new Error("No environment ID found in session storage"));
        }

        const url = !enabled ? `${AppConfig.settings.apiServerPE.apiUrl}user?companyNifs=${companyNif},${environmentId}` : `${AppConfig.settings.apiServerPE.apiUrl}user?companyNifs=${companyNif}?fields=enabled&operator=eq&values=${enabled},${environmentId}`;

        // Crear los headers con la clave API
        const headers = new HttpHeaders({
            'X-API-KEY': AppConfig.settings.apiServerPE.apiKey
        });

        // Realizar la petición GET y devolver el resultado como un Observable
        return this.http.get<AppUsuario[]>(url, { headers: headers });

    }


    getAllModels(): Observable<AppUsuario[]> {
        const environmentId = this._livesSession.EnvironmentId;
        if (!environmentId) {
            return throwError(new Error("No environment ID found in session storage"));
        }

        return this.appEmpresasService.getAllModelsByEnvironment(environmentId).pipe(
            switchMap(empresas => {
                if (empresas.length === 0) {
                    return of([] as AppUsuario[]);
                }
                // Crear un array de observables para cada petición de empresa
                const observables = empresas.map(empresa => {
                    const url = `${AppConfig.settings.apiServerPE.apiUrl}user?fields=company&fields=environment&operator=eq&operator=eq&values=${empresa.company1}&values=${environmentId}`;
                    const headers = new HttpHeaders({
                        'X-API-KEY': AppConfig.settings.apiServerPE.apiKey
                    });
                    return this.http.get<AppUsuario[]>(url, { headers: headers }).pipe(
                        catchError(error => of([] as AppUsuario[]))
                    );

                });
                // Combina todos los observables en uno
                return forkJoin(observables).pipe(
                    map(results => results.reduce((acc, val) => acc.concat(val), [] as AppUsuario[]))
                );
            })
        );
    }



    getModel(id: any): Observable<AppUsuario> {
        const url = `${AppConfig.settings.apiServerPE.apiUrl}user/${id}`;

        // Crear los headers con la clave API
        const headers = new HttpHeaders({
            'X-API-KEY': AppConfig.settings.apiServerPE.apiKey
        });

        // Realizar la petición GET y devolver el resultado como un Observable
        return this.http.get<AppUsuario>(url, { headers: headers });

    }

    getModelProfile(appId: any, nif: any): Observable<AppUsuario> {
        const url = `${AppConfig.settings.apiServerPE.apiUrl}user/profile?AppID=${appId}&Nif=${nif}`;

        // Crear los headers con la clave API
        const headers = new HttpHeaders({
            'X-API-KEY': AppConfig.settings.apiServerPE.apiKey
        });

        // Realizar la petición GET y devolver el resultado como un Observable
        return this.http.get<AppUsuario>(url, { headers: headers });

    }


    public updateUserModel(id: string, companyId: string, data: {}): Observable<AppUsuario> {
        const url = `${AppConfig.settings.apiServerPE.apiUrl}user?user=${id}&Company=${companyId}`;
        // Crear los headers con la clave API
        const headers = new HttpHeaders({
            'Content-Type': 'application/json',
            'X-API-KEY': AppConfig.settings.apiServerPE.apiKey
        });

        // Realizar la petición PATCH y devolver el resultado como un Observable
        return this.http.patch<AppUsuario>(url, data, { headers: headers });
    }

    public createUserOffline(data: any): Observable<any> {
        const environmentId = this._livesSession.EnvironmentId;
        if (!environmentId) {
          return throwError(() => new Error("No environment ID found in session storage"));
        }
      
        const url = `${AppConfig.settings.apiServerPE.apiUrl}user/offline/attendance-licence`;
      
        data.environment = environmentId;
      
        const headers = new HttpHeaders({
          'Content-Type': 'application/json',
          'X-API-KEY': AppConfig.settings.apiServerPE.apiKey
        });
      
        return this.http.post<any>(url, data, { headers }).pipe(
          catchError((error: HttpErrorResponse) => {
            const responseBody = error.error || {};
      
            if (error.status === 409) {
              return throwError(() => ({
                status: 409,
                errorCode: responseBody.errorCode,
                message: responseBody.message || "Conflicto: El recurso ya existe o no puede procesarse."
              }));
            } else if (error.status === 400) {
              return throwError(() => ({
                status: 400,
                message: responseBody.message || "Error 400: Solicitud incorrecta. Revise sus credenciales."
              }));
            } else {
              return throwError(() => ({
                status: error.status,
                message: responseBody.message || "Error en la solicitud."
              }));
            }
          })
        );
      }
      
}